import { StepContext } from '@/contexts/StepContext';
import { Box, Grid } from '@mui/material';
import { FC } from 'react';
import Packages from '../packages/Packages';

const RegistrationStepThree: FC = () => {
    return (
        <StepContext.Provider value={2}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    mt:2
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Grid
                        container
                        spacing={4}
                    >
                        <Grid
                            item
                            xs={12}
                        >
                            <Packages />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </StepContext.Provider>
    );
};

export default RegistrationStepThree;